export default {
  WarehouseReceivingOrders: 'WarehouseReceivingOrders',
  ShowWro: 'ShowWro',
  HideReturns: 'hide-returns',
  AllView: 'all',
  AwaitingView: 'awaiting',
  PartiallyArrivedView: 'partially-arrived',
  ArrivedView: 'arrived',
  ProcessingView: 'processing',
  ReceivedView: 'received',

  // Hub
  HubView: 'hub',
  InternalTransferView: 'internal-transfer',
  DestinationFCView: 'destination-fc'
}
